// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdminProfileUpload.css */

.upload-container {
  min-height: 100vh;
  background-color: #f9fafb;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", sans-serif;
}

.upload-content {
  display: flex;
  padding: 2rem;
}

.upload-wrapper {
  max-width: 42rem;
  margin: 0 auto;
  width: 100%;
}

.upload-card {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  margin-bottom: 1.5rem;
}

.upload-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
}

.upload-subtitle {
  color: #6b7280;
  margin-bottom: 2rem;
}

/* Upload Area */
.upload-area {
  border: 2px dashed #d1d5db;
  border-radius: 0.5rem;
  padding: 2rem;
  text-align: center;
  margin-bottom: 1.5rem;
  transition: border-color 0.2s;
}

.upload-area:hover {
  border-color: #ff6b35;
}

.upload-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.upload-icon-circle {
  width: 5rem;
  height: 5rem;
  background-color: #fff7ed;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

.upload-icon {
  width: 2.5rem;
  height: 2.5rem;
  color: #ff6b35;
}

.upload-text-main {
  color: #374151;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.upload-text-sub {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 1rem;
}

.file-upload-label {
  display: inline-block;
}

.file-input-hidden {
  display: none;
}

.choose-file-button {
  background-color: #ff6b35;
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;
  display: inline-block;
  font-weight: 500;
}

.choose-file-button:hover {
  background-color: #e85a28;
}

.choose-file-button--secondary {
  background-color: #fff;
  color: #174078;
  border: 1px solid #d1d5db;
}

.choose-file-button--secondary:hover {
  background-color: #f0f4ff;
}

.preview-change-label {
  margin-top: 0.25rem;
}

/* Preview */
.upload-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview-image-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 1rem;
}

.preview-image {
  width: 10rem;
  height: 10rem;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #ff6b35;
}

.preview-remove-button {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
  padding: 0.5rem;
}

.preview-remove-button:hover {
  background-color: #dc2626;
}

.remove-icon {
  width: 1rem;
  height: 1rem;
}

.preview-filename {
  color: #374151;
  font-weight: 500;
  margin-bottom: 1rem;
}

/* Buttons */
.button-container {
  display: flex;
  gap: 1rem;
}

.upload-button {
  flex: 1 1;
  background-color: #ff6b35;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: background-color 0.2s;
  font-size: 1rem;
}

.upload-button:hover {
  background-color: #e85a28;
}

.upload-button:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.upload-button.uploading {
  background-color: #9ca3af;
}

.button-icon {
  width: 1.25rem;
  height: 1.25rem;
}

.loading-spinner {
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid white;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.cancel-button {
  padding: 0.75rem 1.5rem;
  border: 2px solid #d1d5db;
  background-color: white;
  color: #374151;
  border-radius: 0.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 1rem;
}

.cancel-button:hover {
  background-color: #f9fafb;
}

.remove-profile-button {
  flex: 1 1;
  background-color: #fff;
  color: #dc2626;
  padding: 0.75rem 1.5rem;
  border: 1px solid #fca5a5;
  border-radius: 0.5rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: background-color 0.2s, border-color 0.2s;
  font-size: 1rem;
}

.remove-profile-button:hover:not(:disabled) {
  background-color: #fef2f2;
  border-color: #f87171;
}

.remove-profile-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Messages */
.message-box {
  margin-top: 1rem;
  border-radius: 0.5rem;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.message-box.success {
  background-color: #f0fdf4;
  border: 1px solid #bbf7d0;
}

.message-box.error {
  background-color: #fef2f2;
  border: 1px solid #fecaca;
}

.message-icon {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.message-icon.success {
  background-color: #22c55e;
}

.message-icon.error {
  background-color: #ef4444;
}

.message-icon .icon {
  width: 1.25rem;
  height: 1.25rem;
  color: white;
}

.message-content {
  flex: 1 1;
}

.message-title {
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.message-box.success .message-title {
  color: #166534;
}

.message-box.error .message-title {
  color: #991b1b;
}

.message-text {
  font-size: 0.875rem;
}

.message-box.success .message-text {
  color: #16a34a;
}

.message-box.error .message-text {
  color: #dc2626;
}

/* Info Card */
.info-card {
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 0.5rem;
  padding: 1rem;
}

.info-title {
  font-weight: 500;
  color: #1e3a8a;
  margin-bottom: 0.5rem;
}

.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 0.875rem;
  color: #1e40af;
}

.info-list li {
  margin-bottom: 0.25rem;
}

/* Responsive */
@media (max-width: 768px) {
  .upload-content {
    padding: 1rem;
  }

  .upload-card {
    padding: 1.5rem;
  }

  .upload-title {
    font-size: 1.25rem;
  }

  .button-container {
    flex-direction: column;
  }

  .preview-image {
    width: 8rem;
    height: 8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ImageUploadPage/ImageUploadPage.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,iBAAiB;EACjB,yBAAyB;EACzB;qCACmC;AACrC;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,wCAAwC;EACxC,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* AdminProfileUpload.css */\n\n.upload-container {\n  min-height: 100vh;\n  background-color: #f9fafb;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", sans-serif;\n}\n\n.upload-content {\n  display: flex;\n  padding: 2rem;\n}\n\n.upload-wrapper {\n  max-width: 42rem;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.upload-card {\n  background-color: white;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  padding: 2rem;\n  margin-bottom: 1.5rem;\n}\n\n.upload-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0.5rem;\n}\n\n.upload-subtitle {\n  color: #6b7280;\n  margin-bottom: 2rem;\n}\n\n/* Upload Area */\n.upload-area {\n  border: 2px dashed #d1d5db;\n  border-radius: 0.5rem;\n  padding: 2rem;\n  text-align: center;\n  margin-bottom: 1.5rem;\n  transition: border-color 0.2s;\n}\n\n.upload-area:hover {\n  border-color: #ff6b35;\n}\n\n.upload-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.upload-icon-circle {\n  width: 5rem;\n  height: 5rem;\n  background-color: #fff7ed;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1rem;\n}\n\n.upload-icon {\n  width: 2.5rem;\n  height: 2.5rem;\n  color: #ff6b35;\n}\n\n.upload-text-main {\n  color: #374151;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n}\n\n.upload-text-sub {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-bottom: 1rem;\n}\n\n.file-upload-label {\n  display: inline-block;\n}\n\n.file-input-hidden {\n  display: none;\n}\n\n.choose-file-button {\n  background-color: #ff6b35;\n  color: white;\n  padding: 0.5rem 1.5rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  display: inline-block;\n  font-weight: 500;\n}\n\n.choose-file-button:hover {\n  background-color: #e85a28;\n}\n\n.choose-file-button--secondary {\n  background-color: #fff;\n  color: #174078;\n  border: 1px solid #d1d5db;\n}\n\n.choose-file-button--secondary:hover {\n  background-color: #f0f4ff;\n}\n\n.preview-change-label {\n  margin-top: 0.25rem;\n}\n\n/* Preview */\n.upload-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.preview-image-wrapper {\n  position: relative;\n  display: inline-block;\n  margin-bottom: 1rem;\n}\n\n.preview-image {\n  width: 10rem;\n  height: 10rem;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 4px solid #ff6b35;\n}\n\n.preview-remove-button {\n  position: absolute;\n  top: -0.5rem;\n  right: -0.5rem;\n  background-color: #ef4444;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 2rem;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  padding: 0.5rem;\n}\n\n.preview-remove-button:hover {\n  background-color: #dc2626;\n}\n\n.remove-icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.preview-filename {\n  color: #374151;\n  font-weight: 500;\n  margin-bottom: 1rem;\n}\n\n/* Buttons */\n.button-container {\n  display: flex;\n  gap: 1rem;\n}\n\n.upload-button {\n  flex: 1;\n  background-color: #ff6b35;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.5rem;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  transition: background-color 0.2s;\n  font-size: 1rem;\n}\n\n.upload-button:hover {\n  background-color: #e85a28;\n}\n\n.upload-button:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.upload-button.uploading {\n  background-color: #9ca3af;\n}\n\n.button-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.loading-spinner {\n  width: 1.25rem;\n  height: 1.25rem;\n  border: 2px solid white;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.cancel-button {\n  padding: 0.75rem 1.5rem;\n  border: 2px solid #d1d5db;\n  background-color: white;\n  color: #374151;\n  border-radius: 0.5rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-size: 1rem;\n}\n\n.cancel-button:hover {\n  background-color: #f9fafb;\n}\n\n.remove-profile-button {\n  flex: 1;\n  background-color: #fff;\n  color: #dc2626;\n  padding: 0.75rem 1.5rem;\n  border: 1px solid #fca5a5;\n  border-radius: 0.5rem;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  transition: background-color 0.2s, border-color 0.2s;\n  font-size: 1rem;\n}\n\n.remove-profile-button:hover:not(:disabled) {\n  background-color: #fef2f2;\n  border-color: #f87171;\n}\n\n.remove-profile-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Messages */\n.message-box {\n  margin-top: 1rem;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.message-box.success {\n  background-color: #f0fdf4;\n  border: 1px solid #bbf7d0;\n}\n\n.message-box.error {\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n}\n\n.message-icon {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.message-icon.success {\n  background-color: #22c55e;\n}\n\n.message-icon.error {\n  background-color: #ef4444;\n}\n\n.message-icon .icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  color: white;\n}\n\n.message-content {\n  flex: 1;\n}\n\n.message-title {\n  font-weight: 500;\n  margin-bottom: 0.25rem;\n}\n\n.message-box.success .message-title {\n  color: #166534;\n}\n\n.message-box.error .message-title {\n  color: #991b1b;\n}\n\n.message-text {\n  font-size: 0.875rem;\n}\n\n.message-box.success .message-text {\n  color: #16a34a;\n}\n\n.message-box.error .message-text {\n  color: #dc2626;\n}\n\n/* Info Card */\n.info-card {\n  background-color: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 0.5rem;\n  padding: 1rem;\n}\n\n.info-title {\n  font-weight: 500;\n  color: #1e3a8a;\n  margin-bottom: 0.5rem;\n}\n\n.info-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-size: 0.875rem;\n  color: #1e40af;\n}\n\n.info-list li {\n  margin-bottom: 0.25rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .upload-content {\n    padding: 1rem;\n  }\n\n  .upload-card {\n    padding: 1.5rem;\n  }\n\n  .upload-title {\n    font-size: 1.25rem;\n  }\n\n  .button-container {\n    flex-direction: column;\n  }\n\n  .preview-image {\n    width: 8rem;\n    height: 8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
